export default __webpack_public_path__ + "5bb7fb124c2d4f694fd7ac0d626f423b.jpg";